import * as React from 'react'
import { TextInput } from 'react-native'
import Colors from '../../constants/Colors'
import { smallTextSize } from '../../constants/GlobalStyle'

import { useState, useEffect } from 'react'

export function PriceMask({ prices, setCustomTip }) {
	const [val, setVal] = useState(prices.tip.toFixed(2)) // Initialize with two decimal places

	return (
		<TextInput
			style={{
				borderWidth: 1,
				borderRadius: 10,
				borderColor: Colors.greyscale[5],
				height: '70%',
				width: 60,
				alignSelf: 'center',
				paddingHorizontal: 5,
				fontSize: smallTextSize,
				fontWeight: 'bold',
				color: global.orgColor ? global.orgColor : Colors.custom.restaurantMain,
				backgroundColor: Colors.custom.lightGrey,
			}}
			placeholder={prices.tip.toFixed(2)}
			keyboardType={'numeric'}
			value={val}
			onChangeText={num => {
				const formattedNum = num.replace(/[^0-9.]/g, '')
				if ((formattedNum.match(/\./g) || []).length <= 1) {
					setVal(formattedNum)
					setCustomTip(formattedNum === '' ? 0 : parseFloat(formattedNum))
				}
			}}
			onFocus={() => {
				setCustomTip(0)
				setVal('')
			}}
			onBlur={() => {
				if (val === '' || isNaN(Number(val))) {
					setVal('0.00')
					setCustomTip(0)
				} else {
					const formattedValue = parseFloat(val).toFixed(2)
					setVal(formattedValue)
					setCustomTip(parseFloat(formattedValue))
				}
			}}
		/>
	)
}

export function PhoneMask({ setPhoneNumber }) {
	return (
		<TextInput
			style={{
				borderWidth: 1,
				borderRadius: 15,
				borderColor: Colors.custom.darkGrey,
				width: 200,
				height: 50,
				marginRight: 50,
				paddingHorizontal: 20,
				marginVertical: 20,
				fontSize: 18,
				fontWeight: 'bold',
				color: global.orgColor ? global.orgColor : Colors.custom.restaurantMain,
				backgroundColor: Colors.custom.lightGrey,
			}}
			placeholder={'Phone Number'}
			keyboardType={'numeric'}
			onChangeText={text => {
				setPhoneNumber(text)
			}}
		/>
	)
}
